import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationComponent } from './pages/verification/verification.component';

const routes: Routes = [
    { path: '', component: VerificationComponent },
    { path: 'verification', component: VerificationComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [],
    declarations: [],
})
export class VerificationRouterModule { }